import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";
import { FormattedMessage } from "react-intl";

const GovernmentOwnershipMenu = connectMenu<MenuProvided>(({ items, refine, currentRefinement }) => {
  const CLEAR_VALUE = "Limpar filtro";
  const selectValue = currentRefinement || CLEAR_VALUE;

  const getOptionLabel = (item: { label: string }) => {
    return item.label === "true" ? (
      <FormattedMessage defaultMessage="Qualquer participação" id="8VD0bn" />
    ) : (
      <FormattedMessage defaultMessage="Sem participação" id="iLm3UR" />
    );
  };

  const selectedOption = selectValue === CLEAR_VALUE ? null : items.find((item) => item.label === selectValue);

  return (
    <div className="space-y-4 font-aeonik font-normal">
      <h3 className="text-base font-bold uppercase tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="Governo como Sócio" id="DKBCKD" />
      </h3>

      <Select
        value={selectValue}
        onValueChange={(value) => {
          refine(value === CLEAR_VALUE ? "" : value);
        }}
      >
        <SelectTrigger>
          <SelectValue
            placeholder={
              currentRefinement === null ? (
                <FormattedMessage defaultMessage="Selecionar filtro" id="DBVwZM" />
              ) : (
                <FormattedMessage defaultMessage="Limpar filtro" id="SJdpi2" />
              )
            }
          >
            {selectedOption && getOptionLabel(selectedOption)}
            {!selectedOption &&
              (currentRefinement === null ? (
                <FormattedMessage defaultMessage="Selecionar filtro" id="DBVwZM" />
              ) : (
                <FormattedMessage defaultMessage="Limpar filtro" id="SJdpi2" />
              ))}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={CLEAR_VALUE}>
            {currentRefinement === null ? (
              <FormattedMessage defaultMessage="Selecionar filtro" id="DBVwZM" />
            ) : (
              <FormattedMessage defaultMessage="Limpar filtro" id="SJdpi2" />
            )}
          </SelectItem>
          {items.map((item) => (
            <SelectItem key={item.label} value={item.label}>
              {getOptionLabel(item)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

export default function GovernmentOwnership() {
  return <GovernmentOwnershipMenu attribute="isGovernmentAShareholder" />;
}
